// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IixD","left":"styles_left__1JpFj"};